import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { EditorComponent } from '../../../base/editor/editor.component';
import { AppService } from '../../../../services/app.service';
import { EngagementService } from '../../../../services/engagements/engagement.service';
import { ActivatedRoute } from '@angular/router';
import { EngagementEnvelope } from '../../../../models/net/envelope/engagement-envelope';
import { EngagementStatus } from '../../../../models/data/talent-core/engagement-status';
import { ResourceSearchResult } from '../../../../models/net/result/resource-search-result';
import { AvatarPrimitive } from '../../../../models/app/avatar-primitive';
import { ProductionSearchResult } from '../../../../models/net/result/production-search-result';
import { ChipSelectorComponent } from '../../../fragments/chip-selector/chip-selector.component';
import { MessageSeverity } from '../../../../enums/message-severity';
import { ProductionRole } from '../../../../models/data/talent-core/production-role';
import { HttpErrorResponse } from '@angular/common/http';
import { EngagementDocument } from '../../../../models/net/envelope/documents/engagement-document';
import { RevisionSearchRequest } from '../../../../models/net/request/revision-search-request';
import { RevisionSearchResult } from '../../../../models/net/result/revision-search-result';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { ActionButton } from '../../../../models/app/action-button';

@Component({
    selector: 'app-engagement',
    templateUrl: './engagement.component.html',
    styleUrls: ['./engagement.component.css', '../../../../app.component.css']
})

export class EngagementComponent extends EditorComponent {

    public engagementStatuses: EngagementStatus[] = [];

    public avatarUrlResource: any;
    public avatarUrlProduction: any;
    public isApiImage: string = 'false';
    public availableResources: AvatarPrimitive[] = [];
    public availableProductions: AvatarPrimitive[] = [];
    public resourceId: number = 0;
    public productionId: number | undefined;
    public selectedResourceIds: number[] = [];
    public selectedProductionIds: number[] = [];
    public availableProductionRoles: ProductionRole[] = [];
    public selectedProductions: AvatarPrimitive[] = [];

    @ViewChild("resourceChipSelector") resourceChipSelector!: ChipSelectorComponent;
    @ViewChild("productionChipSelector") productionChipSelector!: ChipSelectorComponent;
    @ViewChild("appHistory") appHistory!: HistoryComponent;

    public constructor(public override appService: AppService,
                       public override itemService: EngagementService,
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "engagement", "engagements");
    }

    public override ngOnInit(): void {

        super.ngOnInit();
    }

    public ngAfterViewInit(): void {

        this.resourceChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.avatarUrlResource = item.AvatarBlobPath;
        });

        this.resourceChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.avatarUrlResource = this.appService.defaultImageUri;
        });

        this.productionChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.productionId = item.Id;

            this.bindProductionRole(this.productionId);

            this.avatarUrlProduction = item.AvatarBlobPath;
        });

        this.productionChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            (this.itemEnvelope!.Document as EngagementDocument).Item.ProductionRoleId = 0;
            this.availableProductionRoles = [];

            this.avatarUrlProduction = this.appService.defaultImageUri;
        });
    }

    public override handleEditMode = (): void => {

        this.appService.navigateTo("engagement/" + this.itemId.toString(), "");
    }

    public override initializeEnvelope = (envelope: EngagementEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new EngagementEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);
        this.isApiImage = envelope?.Document?.Item?.AvatarBlobPath == null ? "false" : "true";
        this.engagementStatuses = (this.itemEnvelope as EngagementEnvelope).EngagementStatuses;

        const availableResources: AvatarPrimitive[] = (this.itemEnvelope as EngagementEnvelope).AvailableResources.map((i: ResourceSearchResult) => {
            let result = new AvatarPrimitive();
            result.Id = i.ResourceId;
            result.Name = i.FirstName + " " + i.LastName;
            result.AvatarBlobPath = i.AvatarBlobPath;
            return result;
        });

        this.availableResources = availableResources;
        this.resourceId = (this.itemEnvelope as EngagementEnvelope).Document.Item.ResourceId;
        this.selectedResourceIds = [this.resourceId];

        const availableProductions: AvatarPrimitive[] = (this.itemEnvelope as EngagementEnvelope).AvailableProductions.map((i: ProductionSearchResult) => {
            let result = new AvatarPrimitive();
            result.Id = i.ProductionId;
            result.Name = i.Name;
            result.AvatarBlobPath = i.AvatarBlobPath;
            return result;
        });

        this.availableProductions = availableProductions;
        this.productionId = (this.itemEnvelope as EngagementEnvelope).Document.Item.ProductionId;
        this.selectedProductionIds = [this.productionId];

        this.bindProductionRole(this.productionId ?? 0);

        this.avatarUrlResource = this.selectedResourceIds.length > 0 ? this.availableResources.filter((i: AvatarPrimitive) => i.Id == this.selectedResourceIds[0])[0].AvatarBlobPath : this.appService.defaultImageUri;
        this.avatarUrlProduction = this.selectedProductionIds.length > 0 ? this.availableProductions.filter((i: AvatarPrimitive) => i.Id == this.selectedProductionIds[0])[0].AvatarBlobPath : this.appService.defaultImageUri;
    }

    public editAvatar = (): void => {

        this.appService.showPendingFeatureDialog();
    }

    private bindProductionRole = (productionId: number): void => {

        if (this.productionId) {

            this.itemService.getProductionRoles(this.productionId).subscribe((r: ProductionRole[] | null) => {

                if (r != null) {

                    if (r instanceof HttpErrorResponse) {

                        this.appService.IsAppBusy = false;
                        this.availableProductionRoles = [];
                        this.appService.showDialog(MessageSeverity.Error, "Error Getting Statuses", "An error occurred getting engagement statuses", "OK", "", true, true);

                    } else {

                        this.availableProductionRoles = r;
                        this.appService.IsAppBusy = false;
                    }
                }
            });
        }
    }

    public onTabChange(event: MatTabChangeEvent) {

        if (event.index == 1 && !this.isRevisionListLoaded) {

            this.appHistory.searchRevisions();
        }
    }
}
